/**
 * Path prefixes that are reachable without a logged-in session. Used by the
 * Apollo error link (to swallow stray 401s) and by SessionProvider (to skip
 * the `Me` query that would otherwise surface such a 401).
 */
const PUBLIC_PREFIXES = ['/login', '/register-passkey', '/dev-login', '/404', '/500'];

export function isPublicPathname(pathname: string): boolean {
  return PUBLIC_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
